import { SOURCE_ID_TYPE_FILE, SOURCE_ID_TYPE_URL } from 'Constants/index'
import {
  Card,
  Flex,
  FlexItem,
  Modal,
  ModalBody,
  ModalHead,
  Text,
  TEXT_VARIANT_BOLD,
  TEXT_VARIANT_LIGHT
} from 'mailup-web-components'
import iconNewSourceFile from 'mailup-web-components/resources/mailup-web-app/img/svg/new-source_file.svg'
import iconNewSourceUrl from 'mailup-web-components/resources/mailup-web-app/img/svg/new-source_url.svg'
import { modalNewSourceState } from 'Pages/SourcesList/recoil/state/modals'

import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'

import { useRecoilState } from 'recoil'

const ModalNewSource = () => {
  const intl = useIntl()
  const history = useHistory()

  const [showModal, setShowModal] = useRecoilState(modalNewSourceState)

  const handleUrl = () => {
    history.push(`/automation/source/${SOURCE_ID_TYPE_URL}/0`)
    setShowModal(false)
  }

  const handleFile = () => {
    history.push(`/automation/source/${SOURCE_ID_TYPE_FILE}/0`)
    setShowModal(false)
  }

  return (
    <Modal
      show={showModal}
      showClose
      closeOnOverlayClick
      onClose={() => setShowModal(false)}
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.ContentsSouces.NewSourceModalTitle'
        })}
      />
      <ModalBody>
        <Flex alignItems='center' justifyContent='center' margin=' 0 0 24px 0'>
          {intl.formatMessage({
            id: 'Load.ContentsSouces.NewSourceModalDescr'
          })}
        </Flex>
        <Flex columnGap='32px'>
          <FlexItem width='50%'>
            <Card onClick={handleUrl}>
              <div>
                <img src={iconNewSourceUrl} alt='new url' />
              </div>
              <Flex
                flexDirection='column'
                alignItems='center'
                rowGap='8px'
                margin='24px 0 0 0'
              >
                <Text variant={TEXT_VARIANT_BOLD}>
                  {intl.formatMessage({
                    id: 'Load.ContentsSouces.NewUrlTitle'
                  })}
                </Text>
                <Text variant={TEXT_VARIANT_LIGHT}>
                  {intl.formatMessage({
                    id: 'Load.ContentsSouces.NewUrlDescr'
                  })}
                </Text>
              </Flex>
            </Card>
          </FlexItem>
          <FlexItem width='50%'>
            <Card onClick={handleFile}>
              <div>
                <img src={iconNewSourceFile} alt='new file' />
              </div>
              <Flex
                flexDirection='column'
                alignItems='center'
                rowGap='8px'
                margin='24px 0 0 0'
              >
                <Text variant={TEXT_VARIANT_BOLD}>
                  {intl.formatMessage({
                    id: 'Load.ContentsSouces.NewFileTitle'
                  })}
                </Text>
                <Text variant={TEXT_VARIANT_LIGHT}>
                  {intl.formatMessage({
                    id: 'Load.ContentsSouces.NewFileDescr'
                  })}
                </Text>
              </Flex>
            </Card>
          </FlexItem>
        </Flex>
      </ModalBody>
    </Modal>
  )
}

export default ModalNewSource
